import { ReactComponent as VolumeLow } from 'assets/icons/volume-1.svg'
import { ReactComponent as VolumeHigh } from 'assets/icons/volume-2.svg'
import { ReactComponent as Mute } from 'assets/icons/volume-x.svg'
import { useState } from 'react'

const Volume = ({ onChange, value, color }) => {
  const [prevVolume, setPrevVolume] = useState(value)
  function handleVolumeChange(evt) {
    const value = Number(evt.target.value)
    onChange(value)
  }

  function volumeIcon() {
    if (value === 0) {
      return <Mute fill={color} stroke={color} />
    } else if (value < 0.5) {
      return <VolumeLow fill={color} stroke={color} />
    }
    return <VolumeHigh fill={color} stroke={color} />
  }

  function handleToggleMute() {
    if (value > 0) {
      setPrevVolume(value)
      onChange(0)
    } else {
      onChange(prevVolume)
    }
  }

  const volumeRangeStyles = `
    /*********** Baseline, reset styles ***********/
    #player-volume-range {
      -webkit-appearance: none;
      appearance: none;
      background: transparent;
      cursor: pointer;
      width: 120px;
    }

    /* Removes default focus */
    #player-volume-range:focus {
      outline: none;
    }

    /******** Chrome, Safari, Opera and Edge Chromium styles ********/
    /* slider track */
    #player-volume-range::-webkit-slider-runnable-track {
      background-color: #a8a8a8;
      border-radius: 0.5rem;
      height: 0.5rem;
    }

    /* slider thumb */
    #player-volume-range::-webkit-slider-thumb {
      -webkit-appearance: none; /* Override default look */
      appearance: none;
      margin-top: -4px; /* Centers thumb on the track */
      background-color: ${color};
      border-radius: 0.5rem;
      height: 1rem;
      width: 1rem;
    }

    /*********** Firefox styles ***********/
    /* slider track */
    #player-volume-range::-moz-range-track {
      background-color: #a8a8a8;
      border-radius: 0.5rem;
      height: 0.5rem;
    }

    /* slider thumb */
    #player-volume-range::-moz-range-thumb {
      background-color: ${color};
      border: none; /*Removes extra border that FF applies*/
      border-radius: 0.5rem;
      height: 1rem;
      width: 1rem;
    }

    .volume-bar {
      position: absolute;
      left: 8px;
      height: 8px;
      top: 0px;
      border-radius: 100em;
      pointer-events: none;
    }
  `

  return (
    <div className="group flex flex-row items-center">
      <div className="flex flex-row items-center hidden px-2 group-hover:flex relative">
        <style>{volumeRangeStyles}</style>
        <input
          id="player-volume-range"
          type="range"
          min="0"
          max="1"
          step="0.01"
          value={value}
          onChange={handleVolumeChange}
        />
        <div
          className="volume-bar"
          style={{ width: `${value * 85}%`, backgroundColor: color }}
        ></div>
      </div>
      <div className="px-2 flex flex-row items-center">
        <button onClick={handleToggleMute}>{volumeIcon()}</button>
      </div>
    </div>
  )
}

export default Volume
